<template>
  <div id="warrper">
    <!-- 右上角登录信息的下拉菜单配置 -->
    <a-dropdown v-if="currentUser && currentUser.name" placement="bottomRight" style="width: 150px">
      <span class="ant-pro-account-avatar">
        <a-avatar size="small" :src="currentUser.avatar" class="antd-pro-global-header-index-avatar" />
        <!-- 当前的用户名 -->
        <span>{{ currentUser.name }}</span>
      </span>
      <template v-slot:overlay>
        <a-menu class="ant-pro-drop-down menu" :selected-keys="[]">
          <!-- 设置 -->
          <!-- <a-menu-item v-if="menu" key="center" @click="handleToCenter">
          <a-icon type="user" />
          {{ $t('menu.account.center') }}
        </a-menu-item>
        <a-menu-item v-if="menu" key="settings" @click="handleToSettings">
          <a-icon type="setting" />
          {{ $t('menu.account.settings') }}
        </a-menu-item> -->
          <!-- <a-menu-divider v-if="menu" /> -->
          <!-- 退出登录 -->
          <a-menu-item key="logout" @click="handleLogout">
            <a-icon type="logout" />
            退出登录
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
    <span v-else>
      <a-spin size="small" :style="{ marginLeft: 8, marginRight: 8 }" />
    </span>
  </div>
</template>

<script>
import { Modal } from 'ant-design-vue'
import { getAction } from '@/command/netTool'
import { jumpLogin, getDevState } from '@/command/apiTool'

export default {
  name: 'avatar-dropdown',
  props: {
    currentUser: {
      type: Object,
      default: () => null,
    },
    menu: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      tenantValue: null,
    }
  },
  mounted() {},
  methods: {
    handleToCenter() {
      this.$router.push({ path: '/account/center' })
    },
    handleToSettings() {
      this.$router.push({ path: '/account/settings' })
    },
    handleLogout(e) {
      Modal.confirm({
        title: this.$t('layouts.usermenu.dialog.title'),
        content: '您确定要退出吗？',
        onOk: () => {
          // return new Promise((resolve, reject) => {
          //   setTimeout(Math.random() > 0.5 ? resolve : reject, 1500)
          // }).catch(() => console.log('Oops errors!'))
          if (getDevState() == 'dev') {
            return this.$store.dispatch('Logout').then(() => {
              localStorage.setItem('historyUrl', location.href)
              this.$router.push({ name: 'login' })
            })
          } else {
            return this.$store.dispatch('Logout').then(() => {
              jumpLogin()
            })
          }
        },
        onCancel() {},
      })
    },
  },
}
</script>

<style lang="less" scoped>
#warrper {
  display: flex;
  align-items: center;
}
.select_box {
  margin-right: 15px;

  /deep/.ant-select-selection {
    border: none;
  }
}
.ant-pro-drop-down {
  /deep/ .action {
    margin-right: 8px;
  }
  /deep/ .ant-dropdown-menu-item {
    min-width: initial;
  }
}

.ant-avatar-sm {
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 50%;
}
</style>
